import Component from "./Text";
import * as sources from "./components";

export interface ITextExtensions {
    CounterInline: typeof sources.CounterInline;
    Item: typeof sources.Item;
    Link: typeof sources.Link;
}

export const Text: typeof Component & ITextExtensions = Object.assign(
    Component,
    sources,
);

export type { TextProps } from "./Text";
